<template>
  <auth-layout :title="$t('Login')">
    <template v-slot:body>
      <login-form
        reset-password-href="/reset-password"
        register-href="/register"
        @success="handleSuccess"
      />
    </template>
  </auth-layout>
</template>

<script>
import LoginForm from '@shared/auth/LoginForm.vue';

export default {
  components: {
    LoginForm,
  },
  methods: {
    handleSuccess(user) {
      this.$store.dispatch('applyAuthenticatedUser', user);

      const redirectUrl = this.$route.query.redirect_url || '/user-settings/account';
      if (/^https?:\/\//.test(redirectUrl)) {
        window.location.href = redirectUrl;
        return;
      }

      this.$router.replace(redirectUrl).catch(() => {});
    },
  },
  destroyed() {
    this.$store.dispatch('clearErrors');
  },
};
</script>
